/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StyledBundleCard from './BundleCard.styled';
import { Link } from 'react-router-dom';
import CardButton from './CardButton';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isInteger } from 'lodash';
import ColorSelector from './ColorSelector';
import WeightSelector from './WeightSelectorBundle/WeightSelectorBundle';

const BundleCard = React.memo((props) => {
  const {
    className,
    productName,
    imgSrc,
    price,
    salesPrice,
    productId,
    addCart,
    variationType,
    children,
    onSelectProp,
    netWeight_g,
    childId,
    loading,
    brand,
    netWeight,
    placeHolderHeight,
    abbreviated,
    onClick,
    productUrl,
    quantity,
  } = props;

  const [cartSuccess, setCartSuccess] = useState(false);
  const [addProductId, setAddProductId] = useState('');
  const [loadImage, setLoadImage] = useState(false);

  const addCartFunc = (id, count) => {
    setAddProductId(id);
    addCart(id, count, {
      className,
      name: productName,
      imgSrc,
      price,
      productId,
      variationType,
      brand,
      netWeight,
      abbreviated,
      quantity: 1,
    });
  };
  useEffect(() => {
    if ((addProductId === productId || addProductId === childId) && loading) {
      const timer = setTimeout(() => {
        setCartSuccess(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [addProductId]);

  useEffect(() => {
    if (cartSuccess) {
      const timer = setTimeout(() => {
        setCartSuccess(false);
        setAddProductId('');
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cartSuccess]);

  const onError = () => {
    setLoadImage(false);
  };

  const onLoad = (e) => {
    setLoadImage(true);
  };

  const countDecimals = (value) => {
    if (value === null) return '';
    let price = Number(value);
    return isInteger(price) ? price : price.toFixed(2);
  };

  const weight_With_WeightG = `${netWeight} ${netWeight_g}`;

  return (
    <StyledBundleCard className={className} placeHolderHeight={placeHolderHeight}>
      <>
        <Link
          to={`/products/${childId ? `${productUrl}?child=${childId}` : productUrl}`}
          className="product-card__link-to"
          onClick={onClick && onClick}
        >
          <div className={`product-card__media ${loadImage ? 'loaded-image' : ''}`}>
            <LazyLoadImage src={imgSrc} alt="product" onError={() => onError()} afterLoad={() => onLoad()} />
            {!loadImage && <div className="no-image-placeholder" />}
            <p className="t-hidden">Product image</p>
          </div>
          <div className="product-card__details">
            <p className="t-title product-card__title">{productName}</p>
            <div className="product-card__price">
              {!!salesPrice && (
                <p className="product-card__price product-card__sale">
                  <del>${countDecimals(price)}</del>
                </p>
              )}
              {!!salesPrice && <p className="product-card__price">${countDecimals(salesPrice)}</p>}
              {!salesPrice && <p className="">${countDecimals(price)}</p>}
            </div>
          </div>
        </Link>

        {!abbreviated && (
          <>
            <div className="product-card__options">
              {variationType && (variationType === 'color' || variationType === 'weight') && children ? (
                <>
                  {variationType && variationType === 'color' && (
                    <>
                      <h3 className="t-hidden">Type:</h3>
                      <ColorSelector
                        children={children}
                        onSelectProp={onSelectProp}
                        productId={productId}
                        childId={childId}
                        opacity={quantity ? '1' : '0.3'}
                      />
                    </>
                  )}

                  {variationType && variationType === 'weight' && (
                    <>
                      <h3 className="t-hidden">Weight:</h3>
                      <WeightSelector
                        children={children}
                        onSelectProp={onSelectProp}
                        productId={productId}
                        childId={childId}
                      />
                    </>
                  )}
                </>
              ) : (
                ''
              )}

              {!variationType &&
              !(variationType === 'color' || variationType === 'weight') &&
              netWeight &&
              netWeight_g ? (
                <>
                  <h3 className="t-hidden">Weight:</h3>
                  <WeightSelector
                    children={[{ variation: weight_With_WeightG, id: 1 }]}
                    onSelectProp={() => {}}
                    childId={1}
                  />
                </>
              ) : (
                ''
              )}
            </div>

            <div className="product-card__shop">
              <CardButton
                addProductId={addProductId}
                productId={productId}
                productPrice={price}
                childId={childId}
                loading={addProductId === productId || addProductId === childId}
                addCartFunc={addCartFunc}
                cartSuccess={cartSuccess}
                variationType={variationType}
                quantity={quantity}
              />
            </div>
          </>
        )}
      </>
    </StyledBundleCard>
  );
});

BundleCard.propTypes = {
  className: PropTypes.string,
  productName: PropTypes.string,
  price: PropTypes.number.isRequired,
  salesPrice: PropTypes.number,
  imgSrc: PropTypes.string,
  productId: PropTypes.string,
  addCart: PropTypes.func,
  abbreviated: PropTypes.bool,
  netWeight: PropTypes.number,
  netWeight_g: PropTypes.string,
  brand: PropTypes.string,
  variationType: PropTypes.string,
  onSelectProp: PropTypes.func,
  loading: PropTypes.bool,
  lineage: PropTypes.string,
  THC: PropTypes.number,
  CBD: PropTypes.number,
  productUrl: PropTypes.string,
  quantity: PropTypes.string,
  childId: PropTypes.string,
  placeHolderHeight: PropTypes.number,
  onClick: PropTypes.func,
};

export default BundleCard;
